const state = {
  user: null,
  isAuthenticated: false,
  allClients: [] // New state for all clients
}

const mutations = {
  SET_USER(state, user) {
    state.user = user
    state.isAuthenticated = !!user
    // Persist user data in localStorage
    if (user) {
      localStorage.setItem('authUser', JSON.stringify(user))
    } else {
      localStorage.removeItem('authUser')
    }
  },
  UPDATE_USER_PROPERTIES(state, { roles, detalles }) {
    if (state.user) {
      state.user.roles = roles
      state.user.detalles = detalles
      // Update localStorage
      localStorage.setItem('authUser', JSON.stringify(state.user))
    }
  },
  UPDATE_CLIENT_PROPERTIES(state, { id_cliente, cliente_logo, cliente_titulo }) {
    if (state.user) {
      state.user.id_cliente = id_cliente
      state.user.cliente_logo = cliente_logo
      state.user.cliente_titulo = cliente_titulo
      // Update localStorage
      localStorage.setItem('authUser', JSON.stringify(state.user))
    }
  },
  SET_CLIENTES(state, clients) {
    state.allClients = clients
  }
}

const actions = {
  login({ commit }, user) {
    commit('SET_USER', user)
  },
  logout({ commit }) {
    commit('SET_USER', null)
    commit('UPDATE_USER_PROPERTIES', { roles: [], detalles: null })
    commit('UPDATE_CLIENT_PROPERTIES', { id_cliente: null, cliente_logo: null, cliente_titulo: null })
  },
  initializeAuth({ commit }) {
    // Check localStorage for existing session
    const user = localStorage.getItem('authUser')
    if (user) {
      commit('SET_USER', JSON.parse(user))
    }
  },
  updateUserProperties({ commit }, { roles, detalles }) {
    commit('UPDATE_USER_PROPERTIES', { roles, detalles })
  },
  updateClientProperties({ commit }, { id_cliente, cliente_logo, cliente_titulo }) {
    commit('UPDATE_CLIENT_PROPERTIES', { id_cliente, cliente_logo, cliente_titulo })
  },
  setClientes({ commit }, clients) {
    commit('SET_CLIENTES', clients)
  }
}

const getters = {
  isAuthenticated: state => state.isAuthenticated,
  currentUser: state => state.user,
  userRoles: state => state.user ? state.user.roles : [],
  userProperties: state => state.user ? {
    roles: state.user.roles || [],
    detalles: state.user.detalles || null
  } : { roles: [], detalles: null },
  clientProperties: state => state.user ? {
    id_cliente: state.user.id_cliente || null,
    cliente_logo: state.user.cliente_logo || null,
    cliente_titulo: state.user.cliente_titulo || null
  } : { id_cliente: null, cliente_logo: null, cliente_titulo: null },
  clientesUsuario: (state) => {
    if (!state.user || !state.user.roles) return []
    return state.allClients.filter(client => 
      state.user.roles.some(r => r && r.tipo == 'planillero' && 
                                r.ejercicio == String(new Date().getFullYear()) && 
                                r.id_cliente == client.id)
    )
  },
  allClients: state => state.allClients
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} 